import { Button, CircularProgress, Drawer, Grid, TextField, Typography } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { useSubcategoryStore } from "../../../hooks/useSubcategoryStore";
import { useTypeAttributeStore } from "../../../hooks/useTypeAttributeStore";
import { useProductAttributeStore } from "../../../hooks/useProductAttributeStore";

const columns = [
    { type: 'text', field: 'name', label: 'Modelo', align: 'center' },
    { type: 'checkbox', field: 'checkbox', label: '', align: 'center' },  
];

export const DrawerOptimizated: FC<any> = (props): JSX.Element | any => {
    const { open, closeModal } = props;
    const { getReviewData } = useSubcategoryStore();
    const { gettypeAttributeByCompany } = useTypeAttributeStore();
    const { optimizatedproductAttribute } = useProductAttributeStore();
    
    const [data, setData] = useState<any[]>([]);
    const [originalData, setOriginalData] = useState<any[]>([]);  // Estado para mantener la data original
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingSaveReference, setLoadingSaveReference] = useState<boolean>(false);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);  // Estado para filas seleccionadas
    const [idTypeSelected, setIdTypeSelected] = useState<number>(0);
    const [allSelected, setAllSelected] = useState<boolean>(false);

    useEffect(() => {
        getReviewDataAPI();
        gettypeAttributeApi();
    }, []);

    const gettypeAttributeApi = async(search='') => {
        try {
            setLoading(true);
            const response = await gettypeAttributeByCompany(search);
            if(!response){
                setLoading(false);
                return false;
            }else{
                const typeFind = response.find(item => item.name == 'MODELO VERSION')
                setIdTypeSelected(typeFind?.id);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const getReviewDataAPI = async () => {
        setLoading(true);
        try {
            const response = await getReviewData();
            setData(response);
            setOriginalData(response);  // Guardar la data original
        } catch (error) {
            console.error('Error fetching duplicated categories', error);
        } finally {
            setLoading(false);
        }
    };

    const onSearch = (term: string) => {
        if (term) {
            // Filtrar la data original en base al término de búsqueda
            const filteredData = originalData.filter(item => 
                item.name.toLowerCase().includes(term.toLowerCase())
            );
            setData(filteredData);
        } else {
            // Si no hay término de búsqueda, restaurar la data original
            setData(originalData);
        }
    };

    const addReference = async() => {
        // Aquí puedes procesar las filas seleccionadas para unificarlas
        console.log('Filas seleccionadas para unificar:', selectedRows);
        const payload = {
            data: selectedRows,
            idtype: idTypeSelected
        }
        await optimizatedproductAttribute(payload)
        closeModal(); // Cierra el modal después de unificar
    };

    const onCheckbox = (row: any) => {
        const selectedIndex = selectedRows.findIndex(selectedRow => selectedRow.name === row.name);
        let newSelected:any = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selectedRows, row);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selectedRows.slice(1));
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelected = newSelected.concat(selectedRows.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selectedRows.slice(0, selectedIndex),
                selectedRows.slice(selectedIndex + 1)
            );
        }
        setSelectedRows(newSelected);
        setAllSelected(newSelected.length === data.length);
    };

    const selectAllRows = () => {
        if (allSelected) {
            setSelectedRows([]);
            setAllSelected(false);
        } else {
           setSelectedRows(data);
            setAllSelected(true);
        }
    };
    

    const isSelected = (row: any) => selectedRows.some(selectedRow => selectedRow.name === row.name);

    return (
        <>
            <Drawer anchor="right" open={open} onClose={closeModal} ModalProps={{ keepMounted: true }} PaperProps={{ sx: { width: 550 } }}>
                <Grid container spacing={2} padding={4}>
                    <Grid item xs={12}>
                        <Typography variant='h6' component='h1' className='title-main'>Modelos encontrados</Typography>
                    </Grid>

                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'right' }}>
                        <Button
                            sx={{
                                backgroundColor: '#ffffff',
                                border: '1px solid #69ABC3',
                                borderRadius: '10px',
                                color: '#69ABC3',
                                height: '25px',
                                padding: '6px 16px',
                                textTransform: 'none',
                                width: 180,
                                "&:hover": { backgroundColor: "#ffffff" }
                            }}
                            onClick={addReference}
                        >
                            Optimizar registros
                            {loadingSaveReference && (
                                <CircularProgress color="inherit" size={12} sx={{ color: '#5b5b5b', marginLeft: "10px" }} />
                            )}
                        </Button>
                    </Grid>

                    <Grid item xs={12}>
                        <CustomTable
                            disabled_title
                            columns={columns}
                            loading={loading}
                            heightTable={'80%'}
                            rows={data}
                            onRowClick={() => { }}
                            isSelected={isSelected} 
                            onSearch={onSearch}
                            onCheckbox={onCheckbox} 
                            selectAll={selectAllRows}
                            allSelected={allSelected}
                            hasOptions={false}
                            dense
                        />
                    </Grid>
                </Grid>
            </Drawer>
        </>
    );
};
